/* eslint-disable react/prop-types */
import React, { useState } from 'react';
import PropTypes from 'prop-types';
import Collapse from '@mui/material/Collapse';
import ListItem from '@mui/material/ListItem';
import ListItemIcon from '@mui/material/ListItemIcon';
import ListItemText from '@mui/material/ListItemText';
import Checkbox from '@mui/material/Checkbox';
import ExpandLess from '@mui/icons-material/ExpandLess';
import ExpandMore from '@mui/icons-material/ExpandMore';

import StudentsList from '../StudentsList';

const GroupedStudents = ({ groupedStudents, addStudents, removeStudents, isSelectedStudent }) => {
  if (!groupedStudents) {
    return [];
  }

  let key = 0;
  const toRender = [];
  // eslint-disable-next-line
  for (const studentsGroupPair of groupedStudents) {
    if (studentsGroupPair[1].length === 0) {
      continue;
    }

    toRender.push(
      <Group
        key={key}
        groupKey={key}
        studentsGroupPair={studentsGroupPair}
        addStudents={addStudents}
        removeStudents={removeStudents}
        isSelectedStudent={isSelectedStudent}
      />
    );
    key += 1;
  }

  return toRender;
};

const Group = ({ studentsGroupPair, groupKey, addStudents, removeStudents, isSelectedStudent }) => {
  const [isOpen, setIsOpen] = useState(false);
  const [isChecked, setIsChecked] = useState(false);

  function getStudents() {
    return studentsGroupPair[1];
  }

  const handleChange = (event) => {
    if (isChecked) {
      removeStudents(getStudents());
    } else {
      addStudents(getStudents());
    }

    setIsChecked(!isChecked);
    event.stopPropagation();
  };

  const groupName = studentsGroupPair[1].length === 0 ? 'ERROR' : studentsGroupPair[1][0].group.name;

  return (
    <>
      <ListItem button onClick={() => setIsOpen(!isOpen)}>
        <ListItemIcon>
          <Checkbox edge="start" checked={isChecked} disableRipple onClick={handleChange} />
        </ListItemIcon>
        <ListItemText primary={groupName} />
        {isOpen ? <ExpandLess /> : <ExpandMore />}
      </ListItem>
      <Collapse in={isOpen} timeout="auto" unmountOnExit>
        <StudentsList
          students={getStudents()}
          groupKey={groupKey}
          addStudent={(student) => addStudents([student])}
          removeStudent={(student) => removeStudents([student])}
          isSelectedStudent={isSelectedStudent}
        />
      </Collapse>
    </>
  );
};

GroupedStudents.propTypes = {
  groupedStudents: PropTypes.object.isRequired, // Map object
  addStudents: PropTypes.func.isRequired,
  removeStudents: PropTypes.func.isRequired,
  isSelectedStudent: PropTypes.func.isRequired,
};

export default GroupedStudents;
